import {
	ProductsStateActions,
	ProductsState,
	FETCH_CONFIG_PENDING,
	FETCH_CONFIG_SUCCESS,
	FETCH_CONFIG_FAILURE,
} from './types';

const initialState: ProductsState = {
	productInfo: null,
	products: {},
	missingProducts: [],
	galleryItems: [],
	fetchConfigPending: false,
	galleryShoppingProducts: [],
};

export function productsReducer(state = initialState, action: ProductsStateActions): ProductsState {
	switch (action.type) {
		case FETCH_CONFIG_PENDING: {
			return { ...state, fetchConfigPending: true };
		}
		case FETCH_CONFIG_SUCCESS: {
			const { productInfo, products, galleryItems, missingProducts, galleryShoppingProducts } =
				action;
			return {
				...state,
				productInfo,
				products,
				galleryItems,
				missingProducts,
				galleryShoppingProducts,
				fetchConfigPending: false,
			};
		}
		case FETCH_CONFIG_FAILURE: {
			return { ...state, fetchConfigPending: false };
		}
		default:
			return state;
	}
}
